import api from '../services/api';
import { resolveCompanyDocumentFileUrl } from './companyDocumentMappers';

function extractUploadPath(fileUrl) {
  if (!fileUrl) return null;
  const resolved = resolveCompanyDocumentFileUrl(fileUrl);
  if (!resolved) return null;
  try {
    const url = new URL(resolved, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    return url.pathname;
  } catch (_) {
    const pathOnly = String(resolved).replace(/^https?:\/\/[^/]+/i, '');
    return pathOnly.split('?')[0];
  }
}

/**
 * Returns a URL with a one-time download_token for /uploads/* paths (VAPT H04).
 */
export async function getSecureDocumentUrl(fileUrl) {
  const resolved = resolveCompanyDocumentFileUrl(fileUrl);
  if (!resolved) return null;

  const uploadPath = extractUploadPath(fileUrl);
  if (!uploadPath || !uploadPath.startsWith('/uploads/')) {
    return resolved;
  }

  const response = await api.post('/csadmin/documents/file-access-token', { fileUrl: uploadPath });
  const token = response.data?.downloadToken;
  if (!token) return resolved;

  const base = resolved.split('?')[0];
  return `${base}?download_token=${encodeURIComponent(token)}`;
}
